import { useQuery } from "hooks/useQuery";
import { getAvailableBrokers } from "features/Dashboard/service";

export const useSupportedBrokers = () => {
  const { isLoading, data } = useQuery({
    key: "supportedBrokers",
    queryKey: ["supportedBrokers"],
    queryFn: async () => {
      const response = await getAvailableBrokers();
      return response;
    },
  });

  return {
    isLoading,
    brokers: data || [],
  };
};
